import { useQueryClient, useMutation, useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { dataTableParamsBuilder } from "../../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../../utils/hooks/use-pagination-query";
import { http } from "../../../utils/http";

function fetchNoticeList(params) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/notice", baseUrl);

  if (params.title) {
    endpointUrl.searchParams.append("title", params.title);
  }
  if (params.contents) {
    endpointUrl.searchParams.append("contents", params.contents);
  }
  if (params.from) {
    endpointUrl.searchParams.append("from", params.from);
  }
  if (params.to) {
    endpointUrl.searchParams.append("to", params.to);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useNoticeList(params = {}) {
  return usePaginationQuery(
    ["notice", params.title,params.contents,params.from, params.to, params.status],
    (paginationState) => fetchNoticeList({ ...params, ...paginationState })
  );
}
async function addNotice(formData) {
  const data = await http(`/admin/notice`, {
    data: formData,
  });
  return data;
}

export function useAddNotice() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(addNotice, {
    onSuccess: () => {
      queryClient.refetchQueries(["notice"]);
      setTimeout(() => {
        navigate(`/bulletin-board`);
      }, 1500);
    },
  });
}

export function useUpdateNotice(id) {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation(
    async (data) => {
      const { id, ...payload } = data;
      const res = await http(`/admin/notice/${id}`, {
        method: "PUT",
        data: payload,
      });
      return res;
    },
    {
      onSuccess: async (res) => {
        if (res?.response?.data?.ok !== false){
          await queryClient.invalidateQueries(["notice"]);
          setTimeout(() => {
            navigate(`/bulletin-board/notice/${res?.data?.data?.id}`);
          }, 1500);
        }
      },
    }
  );
}

async function deleteNoticeById(id) {
  const data = await http(`/admin/notice/${id}`, {
    method: "DELETE",
  });

  return data;
}

export function useDeleteNoticeById() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation(deleteNoticeById, {
    onSuccess: () => {
      queryClient.invalidateQueries(["notice"]);
      setTimeout(() => {
        navigate("/bulletin-board");
      }, 1500);
    },
  });
}

export async function fetchProductInquiryDownload() {
  const { data } = await http(`/admin/notice-download`, {
    responseType: "blob",
  });

  return data;
}

export function useProductInquiryDownload() {
  const { data, ...raResult } = useQuery(["notice-download"], () =>
    fetchProductInquiryDownload()
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
